import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateBrandingPayload } from '@app-store/slices/onbordingOrganizer/createBranding'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: ICreateBrandingPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.onbordingOrganizer.createBranding

function* createBrandingSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post('/event/branding', payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
            notification.success({
                message: 'Branding updated successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* createBrandingSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createBrandingSagaTask)
}

export default createBrandingSaga
